/**
 * 键盘改键配置的共用片段。
 *
 * 各机型文件从这里组合 Win/Mac Fn 层出厂键与多媒体白名单。
 * 物理键 keywords 必须与各 manifest layout 里的写法一致（如 '?_/'、'{_['、Win_L、↑）。
 */
import type { FactoryKeyMap, KeysCapability } from '@rapoo/device-sdk'

export type KeysConfig = KeysCapability['config']
export type { FactoryKeyMap }

/** 共用的 Fn 层 F 区多媒体出厂映射 */
export const fnFRowStandard: FactoryKeyMap = {
  Esc: 'TOG_LED',
  F1: 'PC',
  F2: '📱',
  F3: '✉',
  F4: '🏠',
  F5: 'Browser_Search',
  F6: 'Music',
  F7: '|◄◄',
  F8: '►►|',
  F9: '►||',
  F10: '📢➕',
  F11: '📢➖',
  F12: '📢✕',
}

/** esk900 三机共用：导航 / WinLock / 灯效方向 */
export const esk900FnCommonNav: FactoryKeyMap = {
  '{_[': 'ScrollLock',
  '}_]': 'PauseBreak',
  ':_;': 'Home',
  '"_\'': 'End',
  Win_L: 'WIN_Lock',
  PgUp: 'LEDMode_Forward',
  PgDn: 'LEDMode_Retreat',
  '↑': 'LED_Inc',
  '↓': 'LED_Dec',
  '←': 'LED_SD',
  '→': 'LED_SI',
}

/** 多数机型共用的多媒体 Tab 白名单（不含侧灯、不含 esk900 额外项） */
export const commonMediaKeys: string[] = [
  '|◄◄',
  '►||',
  '►►|',
  'Stop',
  '📢✕',
  '📢➕',
  '📢➖',
  'Music',
  '✉',
  '🏠',
  '📱',
  'PC',
  'Browser_Search',
  'Browser_Back',
  'Browser_Forward',
  'Browser_Refresh',
  'Browser_Favorites',
  'Power',
  'Sleep',
  'Bright +',
  'Bright -',
  'LED_Inc',
  'LED_Dec',
  '左击',
  '右击',
  '中键',
  '右侧',
  '左侧',
]

/** esk900 相对 commonMediaKeys 额外的多媒体项 */
export const esk900MediaKeysExtra: string[] = [
  'TOG_LED',
  'ScrollLock',
  'PauseBreak',
  'Home',
  'End',
  'LED_Color',
  'WIN_Lock',
  'LEDMode_Forward',
  'LEDMode_Retreat',
  'LED_SI',
  'LED_SD',
]

export const esk900MediaKeys: string[] = [...commonMediaKeys, ...esk900MediaKeysExtra]

/** 75/98 额外侧灯多媒体项 */
export const sideLedMediaKeys: string[] = ['SideLED_Mode', 'SideLED_Color']

/** V700diy 系列 Fn 层出厂键，机型文件按 Win/Mac 分别引用或覆盖 */
export const v700diyFnFactoryKeys: FactoryKeyMap = {
  ...fnFRowStandard,
  '|_\\': 'LED_Color',
  '!_1': 'BT1',
  '@_2': 'BT2',
  '#_3': 'BT3',
  $_4: '24G',
  Delete: 'SideLED',
  Win_L: 'WIN_Lock',
  PgUp: 'LEDMode_Forward',
  PgDn: 'LEDMode_Retreat',
  '↑': 'LED_Inc',
  '↓': 'LED_Dec',
  '←': 'LED_SD',
  '→': 'LED_SI',
  V: 'ChargLED_Switch',
  Space_L: 'Show_Battery_Level',
}
